/* eslint-disable no-unused-vars */
import React, { Dispatch, FunctionComponent, SetStateAction } from 'react';

import { css } from '@emotion/react';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';

import { palette, PRETENDARD_FONT } from '@styles/theme';

interface Props {
  pageNo: number;
  setPageNo: Dispatch<SetStateAction<number>>;
  pageSize: number;
  totalCount: number;
}

const PaginationWithoutQuery: FunctionComponent<Props> = ({
  pageNo,
  setPageNo,
  pageSize,
  totalCount,
}) => {
  const maxDisplayingPageNumbersCount = 5;
  const totalPagesCount =
    Math.floor(totalCount / pageSize) + (totalCount % pageSize === 0 ? 0 : 1);
  const correctedPageNo = Math.max(Math.min(pageNo, totalPagesCount), 1);
  const currentBlockIndex =
    Math.floor(correctedPageNo / maxDisplayingPageNumbersCount) +
    (correctedPageNo % maxDisplayingPageNumbersCount === 0 ? -1 : 0);
  const startPage = currentBlockIndex * maxDisplayingPageNumbersCount + 1;
  const endPage = Math.min(
    startPage + maxDisplayingPageNumbersCount - 1,
    totalPagesCount
  );

  const selectFirstItemOfPrevBlock = () => {
    setPageNo(pageNo - 1);
  };

  const selectFirstItemOfNextBlock = () => {
    setPageNo(pageNo + 1);
  };

  const handlePageSelected = (page: number) => {
    setPageNo(page);
  };

  const numberList: any = [];
  for (let i = startPage; i <= endPage; i++) {
    numberList.push(i);
  }

  return (
    <div css={container}>
      {pageNo > 5 && (
        <>
          <div css={[pageItem]} onClick={() => setPageNo(1)}>
            <a css={link}>
              <FirstPageIcon />
            </a>
          </div>
          <div css={[pageItem]} onClick={selectFirstItemOfPrevBlock}>
            <a css={link}>
              <ChevronLeftIcon />
            </a>
          </div>
        </>
      )}

      {numberList.map((num: any) => (
        <div css={[pageItem]} key={num} onClick={() => handlePageSelected(num)}>
          <span css={[pageLink, num === pageNo && pageLinkActive]}>{num}</span>
        </div>
      ))}
      {totalPagesCount > 5 && !numberList.includes(totalPagesCount) && (
        <>
          <div css={[pageItem]} onClick={selectFirstItemOfNextBlock}>
            <a css={[link, rotate]}>
              <ChevronRightIcon />
            </a>
          </div>
          <div css={[pageItem]} onClick={() => setPageNo(totalPagesCount)}>
            <a css={[link, rotate]}>
              <LastPageIcon />
            </a>
          </div>
        </>
      )}
    </div>
  );
};

export default PaginationWithoutQuery;

const container = css`
  ${PRETENDARD_FONT}
  display: table;
  margin: 40px auto 15px;
`;

const pageItem = css`
  float: left;
  text-align: center;
  cursor: pointer;
  padding: 0;

  & + & {
    margin-left: 10px;
  }
`;

const pageLink = css`
  border: 1px solid ${palette.secondaryColor};
  width: 30px;
  height: 30px;
  line-height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: ${palette.white};
  background-color: ${palette.secondaryColor};
  font-size: 14px;
  box-sizing: border-box;
  transition: 0.3s;
  &:hover {
    color: ${palette.black};
    border-color: ${palette.secondaryColor};
    background-color: ${palette.white};
  }
`;

const pageLinkActive = css`
  color: ${palette.black};
  border-color: ${palette.secondaryColor};
  background-color: ${palette.white};
`;

const link = css`
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid transparent;
  svg {
    fill: ${palette.secondaryColor};
  }

  &:hover {
    border-color: ${palette.secondaryColor};
  }
`;

const rotate = css`
  img {
    transform: rotateY(-180deg);
  }
`;
